var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 46,
    viewBox: "0 0 35 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.883608 0.628418C0.439163 1.15342 0.291016 2.02842 0.291016 3.07842V41.7534C0.291016 42.8034 0.587312 43.6784 1.03176 44.2034L1.17991 44.3784L19.5503 22.6784V22.3284L0.883608 0.628418Z",
    fill: "url(#paint0_linear_240_273)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4745 30.0278L19.4004 22.8528V22.3278L25.4745 15.1528L25.6226 15.3278L32.8819 20.2278C34.9559 21.6278 34.9559 23.9028 32.8819 25.3028L25.4745 30.0278Z",
    fill: "url(#paint1_linear_240_273)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6236 29.852L19.4013 22.502L0.882812 44.377C1.62355 45.252 2.66059 45.252 3.99392 44.552L25.6236 29.852Z",
    fill: "url(#paint2_linear_240_273)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6236 15.1515L3.99392 0.626539C2.66059 -0.248461 1.62355 -0.0734612 0.882812 0.801539L19.4013 22.5015L25.6236 15.1515Z",
    fill: "url(#paint3_linear_240_273)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M25.4754 29.6772L3.99392 44.0272C2.80874 44.9022 1.7717 44.7272 1.03096 44.0272L0.882812 44.2022L1.03096 44.3772C1.7717 45.0772 2.80874 45.2522 3.99392 44.3772L25.4754 29.6772Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M0.883608 44.027C0.439163 43.502 0.291016 42.627 0.291016 41.577V41.752C0.291016 42.802 0.587312 43.677 1.03176 44.202V44.027H0.883608ZM32.8836 24.777L25.4762 29.677L25.6244 29.852L32.8836 24.952C33.9207 24.252 34.3651 23.377 34.3651 22.502C34.3651 23.377 33.7725 24.077 32.8836 24.777Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M3.99472 0.802182L32.8836 20.2272C33.7725 20.9272 34.3651 21.6272 34.3651 22.5022C34.3651 21.6272 33.9207 20.7522 32.8836 20.0522L3.99472 0.627182C1.92065 -0.772818 0.291016 0.277181 0.291016 3.07718V3.25218C0.291016 0.627182 1.92065 -0.597818 3.99472 0.802182Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_240_273",
    x1: 17.7725,
    y1: 2.74592,
    x2: -11.1947,
    y2: 27.2669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_240_273",
    x1: 35.5989,
    y1: 22.5046,
    x2: -0.2485,
    y2: 22.5046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_240_273",
    x1: 22.2561,
    y1: 26.52,
    x2: -17.0241,
    y2: 59.7731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_240_273",
    x1: -3.71422,
    y1: -12.1905,
    x2: 13.8271,
    y2: 2.65934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.7f4d262b56a949451097fed5ac1b3ad2.svg";
export { ForwardRef as ReactComponent };